/* eslint max-classes-per-file: 0 */

import { CollectorPublication as Data } from '@/typings/api/CollectorPublication'
import { AxiosRequestConfig } from 'axios'

import { BaseApiAuth } from '@/api/BaseApiAuth'

export class ImportKimsTasksApi extends BaseApiAuth<Data> {
  protected readonly endpoint = 'collector/kims/';

  public importKims(data: unknown, params?: unknown, config: AxiosRequestConfig = {}) {
    const path = 'import/'
    const [url] = this.getUrl(path)
    return this.request('POST', url, { data, params, ...config })
  }

  public getImportedKims(publication_id: Data['publication_id'], params?: unknown, config: AxiosRequestConfig = {}) {
    const path = `tasks/${publication_id}/import/`
    const [url] = this.getUrl(path)
    return this.request('GET', url, { params, ...config })
  }

  public getImportedKimsByStorage(storage_id: number, config: AxiosRequestConfig = {}) {
    const path = `tasks/${storage_id}/import/storage`
    const [url] = this.getUrl(path)
    return this.request('GET', url, config)
  }
}
